import { Component, Input } from '@angular/core';
import { IFaq } from '../../../type_definitions/datatypes';

@Component({
  selector: 'faq-ticket-category',
  template: `
    <div>
      <label translate>{{label}}</label>

      <div *ngFor="let faq of faqs">
        <faq-item [faqId]="faq.id" [collapsible]="true" [faqData]="faq"></faq-item>
      </div>
    </div>
  `
})
export class FaqTicketCategoryComponent {
  @Input() public label: string;
  @Input() public faqs: IFaq[];
}